import { KeyPlan } from '../../types';
import api from '../../utils/api';

export const createKeyPlan = (variables: KeyPlan) =>
  api.post({
    url: `/property/keyplan`,
    variables,
  });
